import { defineComponent as _defineComponent } from 'vue'
import SolutionsCarouselSlide from '~/components/sections/sliderSection/SolutionsCarouselSlide.vue';
import { useSwiperElement } from '~/composables';

interface Props {
  slides?: any[];
}

interface Emits {
  (e: 'slide-change', data: number): void;
  (e: 'play-video', data: string): void;
  (e: 'init', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsCarouselSlider',
  props: {
    slides: { default: () => [] }
  },
  emits: ["slide-change", "play-video", "init"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'slide-change', data: number): void;
  (e: 'play-video', data: string): void;
  (e: 'init', data: any): void;
}), expose: any, slots: any, attrs: any }) {





const swiperOptions = {
  observer: true,
  navigation: {
    prevEl: '.nav-prev',
    nextEl: '.nav-next',
    disabledClass: 'group-hover:opacity-50 group-hover:hover:opacity-75',
  },
  on: {
    init: (swiper: any) => emit('init', swiper),
    activeIndexChange: (swiper: any) =>
      emit('slide-change', swiper.activeIndex),
  },
};

const swiperEl = useSwiperElement(swiperOptions);

const playVideo = (videoId?: string) => {
  if (videoId) emit('play-video', videoId);
};

return { __sfc: true,emit, swiperOptions, swiperEl, playVideo, SolutionsCarouselSlide }
}

})